import React from "react";

const TimeDisplay = ({ totalSeconds }) => {
  const makeClockReadable = (time) => {
    if (time < 10) { return `0${time}`; }

    return time;
  }

  const minutes = makeClockReadable(Math.floor(totalSeconds / 60)),
        seconds = makeClockReadable(totalSeconds % 60);

  return (
    <span className="time-display">{minutes}: {seconds}</span>
  )
}

export default TimeDisplay;
